// extracted by mini-css-extract-plugin
export var downArrow = "_9n-0";
export var infoTooltipIcon = "_9n-3";
export var label = "_9n-1";
export var optionCard = "_9n-4";
export var upArrow = "_9n-2";